import { Text, Title } from "./Text"

export const PreRegistroSection = (props)=>{
    return (
        <>
        <Title 
            text={props.title}
            fontFamily='Damion-Regular'
            fontSize='70px'
            color='#10609A'
            fontWeight='500'/>
        <Text 
            text={props.subTitle}
            fontFamily='Montserrat-Light'
            fontSize='25px'
            color='#485460'
            fontWeight='900'/>
        <Text 
            text={props.courseTitle}
            fontFamily='Montserrat-Bold'
            fontSize='20px'
            color='#485460'
            marginTop='10px'/>
        </>
    )
}